import { Element, html, css, svg } from "../element";


import {RAF, rand, wrap, clamp, remap } from "../../../utils/ui-utils";
import { simplex3, seed } from "../../../utils/noise";
import ScrollAnimation from "../../../utils/ScrollTimeline";
import { Fireworks } from 'fireworks-js'
import chroma from "chroma-js";

import gsap from "gsap";

import "../harmony/restoration.js"

function particleSource() {
	return svg`<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 101 101"  width="0" height="0">
		<defs>
			<g id="heart"> 
				<path class="cls-2" d="M68.64,11.34c-6.91,0-13.57,2.64-18.61,7.22-5.04-4.59-11.7-7.22-18.61-7.22-15.09,0-27.36,12.27-27.36,27.36,0,8.17,3.7,15.66,10.69,21.65,7.95,6.81,29.61,25.23,29.61,25.23,1.58,1.34,3.6,2.08,5.67,2.08s4.09-.74,5.67-2.08c0,0,21.67-18.42,29.62-25.23,6.99-6,10.69-13.48,10.69-21.65,0-15.09-12.28-27.36-27.36-27.36Z"/>
			</g>
			<g id="circle">
				<circle class="cls-2" cx="49.24" cy="50.5" r="39.98"/>
			</g>
		</defs>
		</svg>`
	}

function treeSource() {
	return svg`
		<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 101.67 128.45" width="0" height="0">
  <defs>
  <g id="tree1">
    <polyline class="cls-3" points="47.08 124.44 47.85 100.54 33.4 75.38 12.28 74.49"/>
    <polyline class="cls-3" points="33.4 75.38 35.93 62.73 26.05 52.17"/>
    <polyline class="cls-3" points="47.85 100.54 60.76 72.11 65.22 54.27 60.76 39.1"/>
    <polyline class="cls-3" points="60.76 72.11 77.71 61.7 87.23 64.08"/>
    <polyline class="cls-3" points="60.76 72.11 48.54 60.34 46.78 43.26 56.59 20.66"/>
    <polyline class="cls-3" points="46.78 43.26 32.5 37.02 27.76 25.6"/>
    <line class="cls-3" x1="21.63" y1="74.65" x2="11.07" y2="60"/>
    <polyline class="cls-1" points="51.94 30.71 45.81 22.53 37.98 20.15"/>
    <line class="cls-1" x1="45.81" y1="22.53" x2="45.81" y2="16.06"/>
    <polyline class="cls-1" points="65.22 54.27 73.4 43.31 72.04 33.77"/>
    <line class="cls-1" x1="73.4" y1="43.31" x2="78.85" y2="38.54"/>
    <polyline class="cls-1" points="77.71 61.7 86.69 52.17 82.94 46.38"/>
    <line class="cls-1" x1="86.69" y1="52.17" x2="93.5" y2="48.08"/>
    <polyline class="cls-1" points="32.53 58.3 35.59 50.46 31.84 45.01"/>
    <line class="cls-1" x1="35.59" y1="50.46" x2="39.34" y2="47.06"/>
    <polyline class="cls-1" points="16.52 66.47 18.9 58.98 14.81 48.42"/>
    <line class="cls-1" x1="16.52" y1="53.53" x2="21.63" y2="45.01"/>
  </g>
  <g id="tree2">
    <polyline class="cls-3" points="47.85 122.15 47.85 100.54 59.78 88.61 64.83 70.67 82.24 64.22"/>
    <polyline class="cls-3" points="59.78 88.61 71.06 89.58 77.51 83.99"/>
    <line class="cls-3" x1="72.35" y1="67.66" x2="75.58" y2="56.27"/>
    <polyline class="cls-3" points="47.85 100.54 42.7 82.06 27.22 72.39"/>
    <line class="cls-3" x1="36.04" y1="77.54" x2="32.38" y2="57.99"/>
    <polyline class="cls-3" points="42.7 82.06 51.29 52.4 39.04 33.92"/>
    <line class="cls-3" x1="46.57" y1="45.31" x2="57.31" y2="27.47"/>
    <line class="cls-3" x1="52.8" y1="34.99" x2="47" y2="15.01"/>
    <line class="cls-1" x1="50.06" y1="23.08" x2="60.13" y2="10.49"/>
    <line class="cls-1" x1="55.41" y1="16.15" x2="54.15" y2="9.54"/>
    <polyline class="cls-1" points="50.06 40.08 59.82 38.51 67.06 26.23"/>
    <line class="cls-1" x1="64.54" y1="32.21" x2="72.73" y2="31.9"/>
    <polyline class="cls-1" points="47.85 50.16 33.37 44.81 23.61 47.96"/>
    <line class="cls-1" x1="33.69" y1="44.81" x2="21.72" y2="32.53"/>
    <line class="cls-1" x1="59.82" y1="38.51" x2="68.01" y2="41.66"/>
    <line class="cls-1" x1="72.41" y1="61.49" x2="65.17" y2="51.42"/>
    <line class="cls-1" x1="34.95" y1="67.16" x2="40.61" y2="58.35"/>
  </g>
  <g id="tree3">
    <polyline class="cls-3" points="53.69 125.51 54.54 85.24 40.51 71.75 30.56 37.87 16.29 31.75"/>
    <polyline class="cls-3" points="54.09 105.76 69.8 87.88 73.05 70.55 87.05 59.19 88.77 39.38"/>
    <line class="cls-3" x1="73.05" y1="70.55" x2="61.64" y2="59.14"/>
    <polyline class="cls-3" points="49.46 40.14 53.79 54.98 38.9 63.66 25.67 56.2 11.81 57.43"/>
    <line class="cls-3" x1="30.56" y1="37.87" x2="38.71" y2="21.56"/>
    <line class="cls-3" x1="49.46" y1="40.14" x2="58.98" y2="18.13"/>
    <polyline class="cls-1" points="29.33 60.28 21.59 70.87 4.47 65.58"/>
    <line class="cls-1" x1="17.52" y1="54.98" x2="10.18" y2="45.61"/>
    <polyline class="cls-1" points="22.41 32.16 22 17.08 15.07 8.52"/>
    <line class="cls-1" x1="22" y1="17.08" x2="27.46" y2="4.46"/>
    <line class="cls-1" x1="33.82" y1="26.05" x2="28.93" y2="17.08"/>
    <polyline class="cls-1" points="68.16 62.8 72.65 46.91 80.8 44.47"/>
    <line class="cls-1" x1="72.65" y1="46.91" x2="69.79" y2="33.06"/>
  </g>
  <g id="tree4">
    <polyline class="cls-3" points="47.53 126.3 47.22 103.5 35.62 89.83 18.35 87.27"/>
    <line class="cls-3" x1="27.08" y1="88.15" x2="20.88" y2="72.95"/>
    <polyline class="cls-3" points="47.22 103.5 54.17 77.36 69.32 70.53 84.48 56.22"/>
    <line class="cls-3" x1="75.25" y1="65.47" x2="73.64" y2="54.9"/>
    <polyline class="cls-3" points="60.6 74.5 64.73 58.2 60.6 43.22"/>
    <line class="cls-3" x1="62.67" y1="50.27" x2="70.7" y2="37.5"/>
    <polyline class="cls-3" points="50.96 85.95 41.54 62.6 25.01 56.66 18.58 44.76"/>
    <polyline class="cls-3" points="32.59 59.74 38.1 46.53 28 36.18"/>
    <polyline class="cls-3" points="41.54 62.6 49.58 35.73 58.53 27.15"/>
    <line class="cls-3" x1="34.2" y1="42.34" x2="36.93" y2="24"/>
    <polyline class="cls-1" points="34.73 31.24 29.69 24 20.56 21.79"/>
    <line class="cls-1" x1="29.69" y1="24" x2="25.28" y2="9.2"/>
    <polyline class="cls-1" points="52.99 31.24 53.31 17.7 46.69 12.98"/>
    <line class="cls-1" x1="52.68" y1="23.37" x2="60.23" y2="14.24"/>
    <polyline class="cls-1" points="46.69 72.17 54.88 57.37 50.79 48.24"/>
    <line class="cls-1" x1="54.88" y1="57.37" x2="58.66" y2="55.48"/>
  </g>
  </defs>
</svg>
	`
}



function halloweenSource() {
	return svg`
<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <defs>
    <g id="bat">
    <path class="cls-2" d="M1.05,40.09c12.64-3.46,34.09,1.22,41.39,12.46-.76-4.29-.77-8.89,2.27-14.74.09,1.88.48,3.41,1.13,5.01,2.36-1.05,5.46-.93,7.29.56,1.34-1.08,1.87-3.5,1.94-4.87,1.57,2.39,1.65,9.23.54,13.31,15.57-14.88,28.1-14.82,42.3-12.64-6.77,3.28-14.57,15.81-15.47,25.53-3.57-11.1-15.66-11.94-17.11-1.43-2.71-8-13.57-3.62-12.78,7.47-.86-4.38-6.85-4.28-8.04,1.03,1.44-12.76-10.92-18.23-16.5-10.25.24-7.49-10.08-10.62-13.85-3.72-.98-6.76-6.47-17.48-13.1-17.71ZM50.22,47.66c2.01.03,3.94-.27,3.51-1.92-.75.88-2.03,1.36-3.51,1.92ZM48.78,47.44c-1.67-.98-3.13-1.69-3.78-2.55.05,1.73,1.72,2.61,3.78,2.55ZM46.82,48.94l-.02-.02c-.08-.07-.15-.12-.21-.16l.82,2.81.17-1.8c.42.29.84.53,1.19.64.56.17,1.11.03,1.62-.22.16-.08.73-.43.88-.53l.17,1.95.69-2.94c-.07.03-.13.06-.19.1-.01,0-.02.01-.03.02,0,0,0,0,0,0l-.51.49c-.38.33-.72.56-1.09.73-.47.22-.97.36-1.49.21-.58-.17-1.35-.72-2-1.29Z"/>

  </g>
  <g id="pubpkin">
    <path class="cls-2" d="M48.97,9.5c.61-.53,1.37-.7,2.07-.7h5.42c1.32,0,2.22,1.31,1.81,2.53-.6,1.84-1.5,4.85-1.89,7.59-.3,2.11-.15,4.4.08,6.18.12.88.25,1.63.36,2.16.05.26.1.47.13.61l.02.1v.06s.02.04.02.04h0s0,.01,0,.01l.05.19c.1-.06.22-.12.36-.2.47-.25,1.15-.56,2.02-.83,1.73-.54,4.19-.91,7.14-.26,1.54.34,2.86,1.05,3.94,1.89.1-.12.24-.27.42-.46.38-.39.94-.9,1.65-1.38,1.41-.96,3.47-1.83,5.89-1.31,2.35.5,4.67,1.98,6.81,4.09,2.14,2.11,4.13,4.89,5.82,8.05,3.38,6.32,5.61,14.26,5.43,21.72-.17,7.1-1.92,14.56-4.98,20.5-3.05,5.93-7.49,10.46-13.1,11.45-2.02.36-3.73-.16-4.91-.75-.59-.3-1.06-.62-1.39-.86-.07-.06-.14-.11-.2-.15-1.28,1.33-3.08,2.67-5.39,3.19-2.95.66-5.41.28-7.14-.26-.86-.27-1.55-.58-2.02-.83-.23-.12-.42-.23-.54-.31h-.01c-1.43,1.13-3.41,2.03-6.1,2.03-2.39,0-4.22-.71-5.6-1.67-.11.07-.26.15-.43.24-.47.25-1.15.56-2.02.83-1.73.54-4.19.91-7.14.26-2.25-.5-4.01-1.78-5.29-3.08-.29.2-.64.41-1.05.62-1.19.59-2.89,1.11-4.91.75-5.61-.99-10.04-5.52-13.1-11.45-3.06-5.94-4.81-13.41-4.98-20.5-.18-7.46,2.05-15.41,5.43-21.72,1.69-3.16,3.68-5.94,5.82-8.05,2.13-2.11,4.45-3.59,6.81-4.09,2.42-.52,4.48.35,5.89,1.31.71.48,1.27.99,1.65,1.38,0,0,0,0,0,0,1.04-.76,2.28-1.41,3.73-1.73,2.95-.66,5.41-.28,7.14.26.59.18,1.1.39,1.51.58-.15-.53-.32-1.28-.44-2.2-.24-1.95-.24-4.71.73-7.94,1.4-4.66,3.34-6.92,4.47-7.9ZM44.44,55.79c-.93.93-2.04,1.67-3.25,2.17-1.22.5-2.52.76-3.84.76s-2.62-.26-3.84-.76c-1.22-.5-2.32-1.24-3.25-2.17-.93-.93-1.67-2.04-2.17-3.25-.5-1.22-.76-2.52-.76-3.84s.26-2.62.76-3.84c.5-1.22,1.24-2.32,2.17-3.25l7.09,7.09,7.09,7.09ZM78.34,65.86c0,1.22,0,3.71-2.43,6.49-2.07,2.37-2.97,2.72-4.68,3.39h0s0,0,0,0c-.3.12-.61.24-.97.39-2.56.86-5.6,1.54-8.95,2.01-3.35.47-6.93.71-10.56.71s-7.21-.24-10.56-.71c-3.35-.47-6.39-1.15-8.95-2.01-.37-.16-.71-.28-1.02-.4-1.66-.64-2.54-.98-4.63-3.37-2.43-2.78-2.43-5.27-2.43-6.49l10.03,3.14,2.95,6.6,2.69-5.35,8.78,1.18,3.14,5.8,3.14-5.8,8.78-1.18,2.69,5.35,2.95-6.6,10.03-3.14ZM71.7,44.86c-.5-1.22-1.24-2.32-2.17-3.25l-7.09,7.09-7.09,7.09c.93.93,2.04,1.67,3.25,2.17,1.22.5,2.52.76,3.84.76s2.62-.26,3.84-.76c1.22-.5,2.32-1.24,3.25-2.17.93-.93,1.67-2.04,2.17-3.25.5-1.22.76-2.52.76-3.84s-.26-2.62-.76-3.84Z"/>
  </g>
  <g id="ground1">
    <path class="cls-2" d="M.79,79.37s10.7-7.34,17.73-7.8c7.03-.46,20.48,7.49,36.84,8.56,16.36,1.07,26.14-3.97,40.97-3.52l5.35.46.15,22.93-101.05.31v-20.94Z"/>
  </g>
  <g id="ground2">
    <path class="cls-2" d="M.66,64.72s7.23-.63,16.92,6.2c8.59,6.05,16.2,16.67,38.66.39,0,0,32.32-19.4,43.78-3.12l.15,31.66-99.66.3.15-35.43Z"/>
  </g>
  </defs>

</svg>
	`
}





const styles = css`
  :host {
    display: block;
    padding: 0;
	position: relative;
    width: 100vw;
    min-height: 2000vh;
	--color-twilight: #362b49;
  }


  .container {
    width: 100vw;
    height: 100vh;
	pointer-events: all;
	position: sticky;
	top: 0;
	z-index: 200;
  }

  .wrapper {
    display: block;
    padding: 0;
	position: relative;
    width: 100vw;
    height: 600vh;
	z-index: 600;
  }
  .inner-wrapper {
	width: 100vw;
    height: 600vh;
  }

  

  .svglib {
	width: 0;
	height: 0;
	overflow: hidden;
  }
  .celebration {
	width: 100vw;
    height: 100vh;
	transform-style: preserve-3d;
	perspective: 600px;
	position: relative;
	left: 0;
	top: 0;
	z-index: 600;
  }




  .particle-container {
	width: 100vw;
    height: 100vh;
	transform-style: preserve-3d;
	position: absolute;
	left: 0;
	top: 0;
  }

  .tree-particles {
	width: 100vw;
    height: 100vh;
	transform-style: preserve-3d;
	position: absolute;
	left: 0;
	top: 0;
	z-index: 400;
  }

  .tree-particles .particle {
	position: absolute;
	width: 100px;
	height: 100px;
	left: calc(50% - 50px);
	top: calc(100% - 50px);
	transform: translate3d(0,0,0);
  }
  .particle svg {
	width: 100%;
	height: 100%;
	fill: red;
  }
  .tree {
	position: absolute;
	left: calc(50% - 200px);
	bottom: calc(0% - 10px);
	width: 400px;
	height: 400px;
	z-index: 1000;
	display: none;
  }
  svg {
	width: 100%;
	height: 100%;
	fill: none;
	stroke-width: 4px;
	stroke-linecap: round;
  }
  svg .cls-1 {
	stroke-width: 1px;
  }	
	.particle svg {
	  stroke: var(--stroke-color, none);
	  fill: var(--fill-color, none);
	  stroke-width: 0.4;
   }


   .tree svg {
	  stroke: var(--stroke-color, black);
   }

   

   .fireworks {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 100;
   }

   .bg {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 100;
		background: #075e2e;
		z-index: 0;
		transition: background 1s ease-in-out;
   }

   .night .bg {
		background: var(--color-night);
   }

   .twilight .bg {
		background: var(--color-twilight);
   }

   .darkness .bg {
		background: var(--color-night);
   }


    harmony-restoration {
		position: relative;
		z-index: 1000;
	}


	.sections {
		width: 100vw;
		height: 100vh;
		position: absolute;
		left: 0;
		top: 0;
		transform-style: preserve-3d;
		z-index: 4000;
		position: sticky;
		top: 0;
		transform-style: preserve-3d;
		perspective: 600px;
	}
	.sections .section {
		width: 100vw;
		height: 100vh;
		position: absolute;
		left: 0;
		top: 0;
		transform-style: preserve-3d;
		//opacity: 0;
	}

	.section.kali .image {
		//transform: translate3d(0,0,200px);	
	}

	.section.halloween svg {
		fill: black;
		stroke: none;
		width: 100%;
		height: 100%;
	}

	.section .item {
		opacity: 0;
	}

   .section.halloween .ground,
   .section.halloween .pumpkin,
   .section.halloween .bat,
   .section.halloween .tree {
		position: absolute;
		left: 50%;
		bottom: 50%;
		width: 200px;
		height: 200px;
   }

   .section.halloween .ground {
		width: 100%;
		height: 50%;
   }

   .section.halloween .pumpkin {
		width: 200px;
		height: 200px;
   }
   .section.halloween .bat1 {
		transform: translate3d(100px,60px,-60px) rotate(-10deg);
   }
   .section.halloween .bat2 {
		transform: translate3d(-100px,100px,60px) rotate(-30deg);
   }
    .section.halloween .bat3 {
		transform: translate3d(-210px,-70px,40px) rotate(20deg)
   }

    .section.halloween .pumpkin1 {
		transform: translate3d(-200px,-100px,-50px);
   }
   .section.halloween .pumpkin2 {
		transform: translate3d(-150px,-150px,60px);
   }

	.image {
		width: 100%;
		height: 100%;	
	}
	.image img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

`



function trees(elem) {
	  const { leafCount = 100, treeCount = 10 } = elem;
	  const particles = Array.from({ length: leafCount }, () => 0);
	  const trees = Array.from({ length: treeCount }, () => rand(1, 4));

	  return html`
		<div class="tree-particles">
			${particles.map(particle => html`
				<div class="particle"> 
					${svg`
						<svg class="leaf" viewBox="0 0 101 101">
							<use href="#circle"></use>
						</svg>`}
				</div>
			`)}
			${trees.map(tree => html`
				<div class="tree">
					${svg`
						<svg class="treebranch" viewBox="0 0 101.67 128.45">
							<use href="#tree${tree}"></use>
						</svg>`}
				</div>
			`
			)}
		</div>
		
	`
}


const particlesTypes = {
	trees
}


const template = function (elem) {
	const { type } = elem;
  return html`
    <div class="container ${elem.timeOfDay}"> 
		<div class="svglib">
			${treeSource()}
			${particleSource()}
			${halloweenSource()}
		</div>
		<div class="wrapper">
			<div class="inner-wrapper">
				<div class="celebration">
					<div class="particle-container">
						${particlesTypes[type](elem)}
					</div>
					<div class="sections">
						<div class="section biodiversity">
						</div>
						<div class="section diwali">
						</div>
						<div class="section kali">
							<div class="item image">
								<img src="https://westridgein.s3.us-east-1.amazonaws.com/media/goddess-kali.png" />
							</div>
						</div>
						<div class="section halloween">
							<div class="item bat bat1">
								${svg`
									<svg viewBox="0 0 100 100">
										<use href="#bat"></use>
									</svg>`}
							</div>
							<div class="item bat bat2">
								${svg`
									<svg viewBox="0 0 100 100">
										<use href="#bat"></use>
									</svg>`}
							</div>
							<div class="item bat bat3">
								${svg`
									<svg viewBox="0 0 100 100">
										<use href="#bat"></use>
									</svg>`}
							</div>
							<div class="item pumpkin pumpkin1">
								${svg`
									<svg viewBox="0 0 100 100">
										<use href="#pumpkin"></use>
									</svg>`}
							</div>
							<div class="item pumpkin pumpkin2">
								${svg`
									<svg viewBox="0 0 100 100">
										<use href="#pumpkin"></use>
									</svg>`}
							</div>

						</div>
						<div class="section girlscout">
						</div>
						<div class="section magicday">
						</div>
						<div class="section unityday">
						</div>
					</div>
				</div>
				
			</div>
		</div>
		
		
		
		<div class="fireworks"></div>
		<div class="bg"></div>
    </div>
	<harmony-restoration @toggle=${elem.onToggle}></harmony-restoration>
  `;
};


const COLORS = {
	day: {
		trees: getGradient(["#f37032", "#603913"], 10),
		leaves: getGradient(["#ffd400", "#067d3f", "#62bb46"], 10),
	},
	night: {
		trees: getGradient(['orange', 'white', 'yellow', 'red'], 10),
		leaves: getGradient(['orange', 'white', 'yellow', 'red'], 10)
	},
	twilight: {
		trees: getGradient(['orange', 'orange', 'yellow', 'orange'], 10),
		leaves: getGradient(['orange', 'orange', 'yellow', 'orange'], 10)
	},
	darkness: {
		trees: getGradient(['orange', 'red', 'red', 'red'], 10),
		leaves: getGradient(['orange', 'red', 'red', 'red'], 10)
	}
}


function getGradient(colors, steps) {

	return chroma.scale(colors).mode('lch').colors(steps);

}



function particle(elem, { xMax , yMax, zMax, colorPalette, ...opts} = {}) {

	xMax = xMax ?? window.innerWidth / 2
	yMax = yMax ??  window.innerHeight / 2
	zMax = zMax ?? 1500

	colorPalette = colorPalette ?? "leaves"

	let x = rand(-xMax, xMax)
	let y = rand(-yMax, yMax)
	let z = rand(-zMax, zMax)

	const colorIndex = rand(0, 10);

	return {
		elem,
		key: rand(0, 10),
		vy: rand(0, 20),
		vz: rand(0, 20),
		vx: rand(0, 20),

		factor: rand(350, 800),
		scaleFactor: rand(1, 3),
		radiusX: rand(100, 200),
		radiusY: rand(100, 200),
		radiusZ: rand(100, 200),

		scale: rand(1, 3),

		get colorIndex() {
			return colorIndex;
		},
		get colorPalette() {
			return colorPalette;
		},
		get x() {
			return x;
		},
		get y() {
			return y;
		},
		get z() {
			return z
		},

		set x(value) {
			x = wrap(value, -xMax, xMax);
		},
		set y(value) {
			y = wrap(value, -yMax, 0);
		},
		set z(value) {
			z = wrap(value, -zMax, zMax);
		}
	}
}



const fwOptions = {
  autoresize: true,
  opacity: 0.5,
  acceleration: 1.05,
  friction: 1.07,
  gravity: 3,
  particles: 50,
  traceLength: 3,
  traceSpeed: 10,
  explosion: 5,
  intensity: 30,
  flickering: 50,
  lineStyle: 'round',
  hue: {
    min: 0,
    max: 360
  },
  delay: {
    min: 30,
    max: 60
  },
  rocketsPoint: {
    min: 50,
    max: 50
  },
  lineWidth: {
    explosion: {
      min: 1,
      max: 3
    },
    trace: {
      min: 1,
      max: 2
    }
  },
  brightness: {
    min: 50,
    max: 80
  },
  decay: {
    min: 0.015,
    max: 0.03
  },
  mouse: {
    click: false,
    move: false,
    max: 1
  }
}



export class Celebration extends Element {
  static template = template;
  static styles = styles;

  static properties = {
    type: { type: String },
	leafCount: { type: Number },
	treeCount: { type: Number },
	timeOfDay: { type: String },
  };

  constructor() {
    super();   

	this.type = "trees";
	this.leafCount = 100;
	this.treeCount = 10;

	this.timeOfDay = "day";
  }

  

  onClick(e) {
	
  }

  setFireworks(state) {
	if (!this._fireworks) {
		const fwctr = this.qs('.fireworks')
		const fireworks = new Fireworks(fwctr, fwOptions)
		this._fireworks = fireworks;
	}
	
	if (state) {	
		if (!this.fireworksState) {
			this._fireworks.start()
			this.fireworksState = true;
		}			
	} else {
		if (this.fireworksState) {
			this._fireworks.stop()
			this.fireworksState = false;
		}	
	}

  }

  onToggle(e) {
	const { target } = e;
	const originalEvent = e.detail.event

	if (e.detail.name === "restoration") {
		this.setFireworks(false);
		this.timeOfDay = "day"		
	}
	if (e.detail.name === "diwali") {
		this.setFireworks(true);
		this.timeOfDay = "night"		
	}
	if (e.detail.name === "halloween") {
		this.timeOfDay = "twilight"
		this.setFireworks(false);
		this.showSection("halloween", originalEvent.isActive, originalEvent.direction)
	}
	if (e.detail.name === "kali") {
		
		this.timeOfDay = "darkness"
		this.setFireworks(false);
		this.showSection("kali", originalEvent.isActive, originalEvent.direction)
	}
	if (e.detail.name === "days") {		
		this.timeOfDay = "night"
		this.setFireworks(false);
		this.showSection("days", originalEvent.isActive, originalEvent.direction)
	}
  }


 attachedCallback() {

	const main = this.qs(".container");

	const container = this.qs(".particle-container");
	const wrapper = this.qs(".wrapper");

	
	const { context, palette, mode } = this


	const elements = this.qsa(".particle");
	const treeElements = this.qsa(".tree");

	const sections = this.qsa(".section");

	const particles = [...elements].map((h, i) => particle(h, { 
		xMax : window.innerWidth, 
		colorPalette: "leaves",
	}));
	const trees = [...treeElements].map((h, i) => particle(h, { 
		xMax: window.innerWidth, yMax: 0, zMax: 1500, 
		colorPalette: "trees", 
	}));


	let depth = 0


	const tl = ScrollAnimation(wrapper, { debug: false, 
		onUpdate: (e) => {
			depth = e.progress
			//console.log("depth", depth)
		}
	});
	tl.fromTo(container, { rotateY: 0, translateZ: 2000}, 
			{ rotateY: 0, duration: 0.3, translateZ: -2000, ease: "power1.inOut" }, 0);

	tl.fromTo(container, { rotateY: 0}, 
			{ rotateY: 0, duration: 0.9, ease: "power1.inOut" }, 0.2);

	


	

	const raf = new RAF((time) => {	
		const { analyser, beat } = context.audio || {};

		trees.forEach((tree, i) => {
				let { elem, key, x, y, z, scale, currentColor, colorIndex, colorPalette } = tree;
				let opacity = remap(z, -1500, 1500, 0, 1)

				const color = COLORS[this.timeOfDay][colorPalette][colorIndex]

				if (color !== currentColor) {
					elem.style.setProperty('--stroke-color', color);
					tree.currentColor = color;
				}
				elem.style.opacity = opacity
				elem.style.transform = `translate3d(${x}px, ${y+100}px,  ${z}px) scale3d(${scale},${scale},1)`;
			})

		particles.forEach((heart, i) => {

			//heart.x += heart.vx;
			//heart.y += heart.vy;
			//heart.z += heart.vz;

			let { elem, key, x, y, z, scale, opacity = 0, currentColor, colorPalette, colorIndex  } = heart;

			if (analyser) {
				const { data, peaks} = analyser
				const d = data[ i] || 0;
				const p = peaks[ i] || 0;

				const n = simplex3(x, x, time/1000);
				const ny = simplex3(y, y, time/1000);

				x = x + n * 250 // Math.sin(time / 500 * ((key + 1) / 10)) * 200
				y = y - (ny * 200);
				//z = z + Math.cos(time / 500 * ((key + 1) / 10)) * 100

				scale = (scale + (p * 10)) ;

				opacity = remap(z, -1500, 1500, 0, 1)
			}

			const color = COLORS[this.timeOfDay][colorPalette][colorIndex]
			if (color !== currentColor) {
					if (this.timeOfDay === "night") {
						elem.style.setProperty('--stroke-color', color);
						elem.style.setProperty('--fill-color', 'none');
					} else {
						elem.style.setProperty('--fill-color', color);
						elem.style.setProperty('--stroke-color', 'none');
					}
					
					heart.currentColor = color;
				}
			
			elem.style.opacity = opacity
			elem.style.transform = `translate3d(${x}px, ${y}px,  ${z}px) scale3d(${scale},${scale},1)`;
		})

	});

	return () => {
		raf.cancel();
		tl.kill();
	}
	
  }


  showSection(name, isActive, dir) {
	const section = this.qs(`.section.${name}`);

	if (!section) return;

	if (isActive) {

		if (dir === 1) {
			// came from below
			this.secAnim = gsap.fromTo(section,
			{ translateZ: 200,  }, 
			{ translateZ: 100,  duration: 1, ease: "power1.inOut", onUpdate: (e) => {}})

			gsap.to(section.querySelectorAll(".item"), { opacity: 1, duration: 1, ease: "power1.inOut" });
		} else if (dir === -1) {
			// came from above1

			this.secAnim = gsap.fromTo(section,
			{ translateZ: -200, }, 
			{ translateZ: 100,  duration: 1, ease: "power1.inOut", onUpdate: (e) => {}})
			gsap.to(section.querySelectorAll(".item"), { opacity: 1, duration: 1, ease: "power1.inOut" });
		}


	} else {
		// inactive
		if (dir === 1) {
			// went up
			this.secAnim = gsap.fromTo(section,
			{ translateZ: 100 }, 
			{ translateZ: -200, duration: 1, ease: "power1.inOut", onUpdate: (e) => {}})
			gsap.to(section.querySelectorAll(".item"), { opacity: 0, duration: 1, ease: "power1.inOut" });
		} else if (dir === -1) {
			// went down
			this.secAnim = gsap.fromTo(section,
			{ translateZ: 100 }, 
			{ translateZ: 200, duration: 1, ease: "power1.inOut", onUpdate: (e) => {}})
			gsap.to(section.querySelectorAll(".item"), { opacity: 0, duration: 1, ease: "power1.inOut" });
		}
	}
	
  }

}

customElements.define("harmony-fireworks", Celebration);
